import { Button } from "@/modern/components/ui/button";
import { Upload, Loader2 } from "lucide-react";
import { useRef, useState } from "react";
import { useMyMediaContext } from "../context/MyMediaContext";
import { toast } from "sonner";

export const UploadButton = () => {
  const { uploadAndCreateUnassignedFile } = useMyMediaContext();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);

    if (fileArray.length === 0) {
      e.target.value = "";
      return;
    }

    setIsUploading(true);
    const fileCount = fileArray.length;
    const fileText = fileCount === 1 ? "file" : "files";

    try {
      toast.loading(`Uploading ${fileCount} ${fileText}...`, {
        id: "my-media-upload",
      });

      await Promise.all(fileArray.map((file) => uploadAndCreateUnassignedFile(file)));

      toast.success(`Successfully uploaded ${fileCount} ${fileText}`, {
        id: "my-media-upload",
      });
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(`Failed to upload ${fileText}. Please try again.`, {
        id: "my-media-upload",
      });
    } finally {
      setIsUploading(false);
      e.target.value = "";
    }
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        className="hidden"
        onChange={handleFileSelect}
      />
      <Button
        onClick={() => fileInputRef.current?.click()}
        disabled={isUploading}
        size="sm"
      >
        {isUploading ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" />
            Uploading...
          </>
        ) : (
          <>
            <Upload className="h-4 w-4" />
            Upload Files
          </>
        )}
      </Button>
    </>
  );
};
